import { render, staticRenderFns } from "./MetaAvatar.vue?vue&type=template&id=c1bb8994&scoped=true&"
import script from "./MetaAvatar.vue?vue&type=script&lang=js&"
export * from "./MetaAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bb8994",
  null
  
)

export default component.exports